import React, { Fragment, useEffect, useState, useMemo, useCallback } from "react";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner, Collapse, UncontrolledButtonDropdown, UncontrolledDropdown, DropdownItem, DropdownMenu, DropdownToggle, ButtonGroup } from "reactstrap";
import moment from 'moment';
import 'moment-timezone';
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import { isEmpty, clone } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { resetClientState, getClient } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { getBranch, resetBranchState } from "../../../store/branch/action";
import { getSalesChannel, resetSalesChannelState } from "../../../store/salesChannel/action";
import { resetSalesTargetState, getSalesTarget as onGetSalesTargets, addNewSalesTarget as onAddNewSalesTarget, updateSalesTarget as onUpdateSalesTarget, deleteSalesTarget as onDeleteSalesTarget, getSalesTargetLoading } from "../../../store/salesTarget/action";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ExportCSVModal from "../../../Components/Common/ExportCSVModal";

const SalesTarget = () => {
  const [modal, setModal] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();

  const { salesTargets, isSalesTargetCreated, isSalesTargetSuccess, loading, error, salesChannelLoading, salesChannels, clients, clientLoading, branches, branchLoading, companies, companyLoading } = useSelector((state) => ({
    salesTargets: state.SalesTarget.salesTargets,
    isSalesTargetCreated: state.SalesTarget.isSalesTargetCreated,
    isSalesTargetSuccess: state.SalesTarget.isSalesTargetSuccess,
    loading: state.SalesTarget.loading,
    clients: state.Client.clients,
    clientLoading: state.Client.loading,
    companies: state.Company.companies,
    companyLoading: state.Company.loading,
    branches: state.Branch.branches,
    branchLoading: state.Branch.loading,
    salesChannels: state.SalesChannel.salesChannels,
    salesChannelLoading: state.SalesChannel.loading,
    error: state.SalesTarget.error,
  }));

  const [salesTargetList, setSalesTargetList] = useState([]);
  const [salesTarget, setSalesTarget] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [channelList, setChannelList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);

  const [isSearch, setIsSearch] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const statusActiveData = [
    {
      options: [
        { label: "DRAFT", value: "1" },
        { label: "ACTIVE", value: "2" },
        { label: "INACTIVE", value: "3" },
      ],
    }];
  const onClickDelete = (salesTarget) => {
    setSalesTarget(salesTarget);
    setDeleteModal(true);
  };

  const handleDeleteSalesTarget = () => {
    if (salesTarget) {
      dispatch(onDeleteSalesTarget(salesTarget));
      setDeleteModal(false);
    }
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  useEffect(() => {
    setSalesTargetList(salesTargets);
  }, [salesTargets]);

  useEffect(() => {
    if (!isEmpty(salesTargets)) {
      setSalesTargetList(salesTargets);
    }
  }, [salesTargets]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredSalesTargets = salesTargets;
      if (type !== "all") {
        filteredSalesTargets = salesTargets.filter((salesTarget) => salesTarget.sales_target_status.name === type);
      }
      setSalesTargetList(filteredSalesTargets);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      setIsSearch(true);
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });

        dispatch(resetSalesTargetState())
        dispatch(onGetSalesTargets());
        dispatch(getClient());
        dispatch(getSalesChannel());

        handleGetCompany(obj.data.clientId);
        handleGetBranch(obj.data.companyId);

      }
    }
  }, [dispatch, salesTargets, isSearch]);

  useEffect(() => {
    setSalesTarget(salesTargets);
  }, [salesTargets]);

  useEffect(() => {
    if (!isEmpty(salesTargets)) {
      setSalesTarget(salesTargets);
      setIsEdit(false);
    }
  }, [salesTargets]);

  useEffect(() => {
    setSalesTargetList(salesTargets);
  }, [salesTargets]);

  useEffect(() => {
    if (!isEmpty(salesTargets)) setSalesTargetList(salesTargets);
  }, [salesTargets]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    if (!isEmpty(salesChannels)) {
      var data = [];
      var opt = [];
      salesChannels.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setChannelList(data);
    }
  }, [salesChannels]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    (branches || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (branches.length > 0) {
      setBranchList(data);
    }
  }, [branches]);


  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      validation.resetForm();
      validation.setErrors({});
    } else {
      setModal(true);
    }
  }, [dispatch, modal]);


  const handleSalesTargetClick = useCallback((arg) => {
    const data = arg;

    setSalesTarget({
      id: data.id,
      description: data.description,
      targetat: `${moment(data.startat)

        .format("YYYY/MM/DD hh:mm")} to ${moment(data.endat)

          .format("YYYY/MM/DD hh:mm")}`,
      channel: data.sales_target_channel === null ? "" : { label: data.sales_target_channel.name ?? "", value: data.sales_target_channel.id ?? "" },
      client: data.sales_target_client === null ? "" : { label: data.sales_target_client.name ?? "", value: data.sales_target_client.id ?? "" },
      company: data.sales_target_company === null ? "" : { label: data.sales_target_company.name ?? "", value: data.sales_target_company.id ?? "" },
      branch: data.sales_target_branch === null ? "" : { label: data.sales_target_branch.name ?? "", value: data.sales_target_branch.id ?? "", companyId: data.sales_target_branch.companyId ?? "" },
      amount: data.amount
    });

    setIsEdit(true);
    toggle();
  }, [toggle, userType]);

  const checkedAll = () => {
    const checkall = document.getElementById("checkBoxAll");
    const ele = document.querySelectorAll(".dataCheckbox");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckbox:checked");
    const checkall = document.getElementById("checkBoxAll");
    ele.forEach((element) => {
      dispatch(onDeleteSalesTarget(element.value));
    });
    checkall.checked = false;
  };

  const onClickApprove = (branch) => {
    setSalesTarget(branch);
    setApproveModal(true);
  };

  const handleApproveBranch = () => {
    if (salesTarget) {
      salesTarget.setApprove = true;
      dispatch(onUpdateSalesTarget(salesTarget));
      dispatch(resetSalesTargetState());
      dispatch(onGetSalesTargets());
      setApproveModal(false);
    }
  };

  function currencyFormat(num) {
    return 'Rp ' + parseFloat(num).toLocaleString(['ban', 'id'])
  }

  const columns = useMemo(() => [
    {
      id: "#",
      Header: <input type="checkbox" id="checkBoxAll" className="form-check-input" onClick={() => checkedAll()} />,
      Cell: (cellProps) => {
        let data = cellProps.row.original;
        return (
          <div className="hstack gap-2 mt-4 mt-sm-0">
            <input type="checkbox" className="dataCheckbox form-check-input me-2" value={data.id} />
            <ButtonGroup className="me-1">
              <UncontrolledButtonDropdown>
                <Button color="light"
                  className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("updateSalesTarget") !== -1 ? "btn-sm" : "btn-sm d-none"}
                  onClick={() => {
                    handleSalesTargetClick(data);
                  }}><i className="ri-edit-2-line fs-15"></i></Button>
                <Button color="light"
                  className={userType === "admin" || userType === "client" ? "btn-sm" : userRole && userRole.split(",").indexOf("deleteSalesTarget") !== -1 ? "btn-sm" : "btn-sm d-none"}
                  onClick={() => {
                    onClickDelete(data);
                  }}><i className="ri-delete-bin-line fs-15 text-danger"></i></Button>
              </UncontrolledButtonDropdown>
            </ButtonGroup>
            {cellProps.row.original.statusId === 1 && (
              <button
                className={userType === "admin" || userType === "client" ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : userRole && userRole.split(",").indexOf("approveSalesTarget") !== -1 ? "btn-label btn btn-sm btn-soft-success fs-12 ms-2" : "btn-label btn btn-sm btn-soft-success fs-12 ms-2 d-none"}
                onClick={() => {
                  onClickApprove(data);
                }}>
                <i className="ri-checkbox-circle-line label-icon align-middle fs-16 me-1"></i>Approve
              </button>
            )}
          </div>
        );
      },
    },
    {
      Header: "Proyek",
      accessor: "sales_target_branch.name",
      filterable: true,
    },
    {
      Header: "Target Periode",
      accessor: "endat",
      filterable: true,
      Cell: (data) => (
        <>
          {handleValidDate(data.row.original.startat)} -
          {handleValidDate(data.row.original.endat)}
        </>
      ),
    },
    {
      Header: "Nilai",
      accessor: "amount",
      filterable: true,
      Cell: (amount) => (
        <> {currencyFormat(amount.row.original.amount)} </>
      ),
    },
    {
      Header: "Keterangan",
      accessor: "description",
      filterable: true,
    },
    {
      Header: 'Status',
      accessor: 'sales_target_status.name',
      filterable: true,
      Cell: (cell) => {
        switch (cell.value) {
          case "DRAFT":
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
          case "ACTIVE":
            return <span className="badge text-uppercase badge-soft-info"> {cell.value} </span>;
          case "INACTIVE":
            return <span className="badge text-uppercase badge-soft-danger"> {cell.value} </span>;
          default:
            return <span className="badge text-uppercase badge-soft-warning"> {cell.value} </span>;
        }
      }
    }], [handleSalesTargetClick, userRole, userType]);


  const [filterDate, setFilterDate] = useState(null);

  const handleValidDate = date => {
    return moment(date, "YYYY/MM/DD").format("MMM D, YYYY");
  };

  const handleValidTime = (time) => {
    return moment(time, "YYYY/MM/DD").format('HH:mm');
  };

  //TABLE
  const { getTableProps, rows, getTableBodyProps, headerGroups, page, prepareRow, canPreviousPage, canNextPage, pageOptions, gotoPage, nextPage, previousPage, setPageSize, preGlobalFilteredRows, setGlobalFilter, state: { pageIndex, pageSize } } = useTable(
    {
      columns: columns,
      data: salesTargetList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0, pageSize: 10, selectedRowIds: 0,
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable ? (column.isSorted ? (column.isSortedDesc ? " sorting_desc" : " sorting_asc") : " sort") : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => { setGlobalFilter(value || undefined); }, 600);

  function handleFilter() {
    let targetat = '';
    let endat = '';
    let datearr = filterDate.split(' to ');
    if (datearr[1]) {
      targetat = datearr[0];
      endat = datearr[1] ? datearr[1] : datearr[0];
    }

    var company = statusActive.value ? statusActive.value : '';
    const param = {
      "title": searchValue,
      "targetat": targetat,
      "endat": endat,
      "company": company
    }
    dispatch(onGetSalesTargets(param));
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      client: (salesTarget && salesTarget.client) || clientSelected,
      company: (salesTarget && salesTarget.company) || companySelected,
      description: (salesTarget && salesTarget.description) || '',
      channel: (salesTarget && salesTarget.channel),
      targetat: (salesTarget && salesTarget.targetat),
      branch: (salesTarget && salesTarget.branch),
      amount: (salesTarget && salesTarget.amount),
    },
    validationSchema: Yup.object({
      client: Yup.object().required("Please Pick Client"),
      company: Yup.object().required("Please Pick Company"),
      amount: Yup.string().required("Please Enter Rate"),
      branch: Yup.object().required("Please Pick branch"),
      targetat: Yup.string().required("Please Pick Effective Date")
    }),
    onSubmit: (values) => {
      let datearr = values.targetat.split(" to ");
      let startat = datearr[0] && datearr[0];
      let endat = datearr[1] ? datearr[1] : datearr[0] && datearr[0];
      dispatch(getSalesTargetLoading());
      if (isEdit) {
        const updateSalesTarget = {
          id: salesTarget ? salesTarget.id : 0,
          statusId: 1,
          description: values.description,
          startat: startat,
          endat: endat,
          amount: values.amount,
          channelId: values.channel.value,
          clientId: values.client.value,
          branchId: values.branch.value,
          companyId: values.company.value
        };
        dispatch(onUpdateSalesTarget(updateSalesTarget));
        validation.resetForm();
      } else {
        const newSalesTarget = {
          statusId: 1,
          description: values.description,
          startat: startat,
          endat: endat,
          amount: values.amount,
          channelId: values.channel.value,
          clientId: values.client.value,
          branchId: values.branch.value,
          companyId: values.company.value
        };
        dispatch(onAddNewSalesTarget(newSalesTarget));
        validation.resetForm();
      }
      toggle();
    },
  });

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetBranch = (id) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: id }));
  };

  document.title = "SalesTargets | Enterprise Resources Planning";

  return (
    <div className="page-content">
      <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={salesTargetList} />
      <DeleteModal show={deleteModal} onDeleteClick={handleDeleteSalesTarget} onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={salesTarget && salesTarget.sales_target_branch ? salesTarget.sales_target_branch.name + " - " + salesTarget.amount : ""} show={approveModal} onApproveClick={handleApproveBranch} onCloseClick={() => setApproveModal(false)} />
      <DeleteModal show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)} />
      <Container fluid>
        <BreadCrumb title="Target Penjualan" pageTitle="Human Resources" />
        <Row>
          <Col lg={12}>
            <Card id="salesTargetList">
              <CardHeader className="card-header border-0">
                <div className="d-flex align-items-center">
                  <h5 className="card-title mb-0 flex-grow-1">
                    Target Penjualan &nbsp;{isLoading ? (<>
                      <Spinner color="primary" type="grow" size={"sm"}> Loading... </Spinner>&nbsp;
                      <Spinner color="success" type="grow" size={"sm"}> Loading... </Spinner>&nbsp; </>) : ""}
                  </h5>
                  <div className="flex-shrink-0">
                    <button type="button" className={
                      userType === "admin"
                        ? "btn btn-primary add-btn me-2"
                        : userRole &&
                          userRole.split(",").indexOf("createSalesTarget") !== -1
                          ? "btn btn-primary add-btn me-2"
                          : "btn btn-primary add-btn me-2 d-none"
                    } id="create-btn" onClick={() => { setSalesTarget(""); setIsEdit(false); toggle(); }}>
                      <i className="ri-funds-line align-bottom fs-14"></i> Tambah
                    </button>
                    <button type="button" className="btn btn-success ms-1" onClick={() => setIsExportCSV(true)}>
                      <i className="ri-file-download-line align-bottom fs-14"></i>  Export
                    </button>
                    <button className={userType === "admin" || userType === "client" || userType === "company" ? "btn btn-soft-danger ms-1 add-btn" : userRole && userRole.split(",").indexOf("deleteSalesTarget") !== -1 ? "btn btn-soft-danger ms-1 add-btn" : "btn btn-soft-danger ms-1 add-btn d-none"} onClick={() => setDeleteModalMulti(true)}>
                      <i className="ri-delete-bin-5-line align-bottom fs-15"></i> Delete</button>
                  </div>
                </div>
              </CardHeader>
              <CardBody className="pt-0">
                <div>
                  <Nav className="nav-tabs nav-tabs-custom nav-success" role="tablist" >
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "1" }, "fw-semibold")} onClick={() => { toggleTab("1", "all"); }} href="#">
                        <i className="ri-funds-line me-1 align-bottom fs-14"></i>  All TARGET
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "2" }, "fw-semibold")} onClick={() => { toggleTab("2", "DRAFT"); }} href="#">
                        <i className="ri-information-line me-1 align-bottom fs-14"></i>  DRAFT
                      </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "3" }, "fw-semibold")} onClick={() => { toggleTab("3", "ACTIVE"); }} href="#">
                        <i className="ri-checkbox-circle-line me-1 align-bottom fs-14"></i>  ACTIVE    </NavLink>
                    </NavItem>
                    <NavItem>
                      <NavLink className={classnames({ active: activeTab === "4" }, "fw-semibold")} onClick={() => { toggleTab("4", "INACTIVE"); }} href="#">
                        <i className="ri-indeterminate-circle-line me-1 align-bottom fs-14"></i>  INACTIVE
                      </NavLink>
                    </NavItem>
                  </Nav>
                  <Row className="mb-3">
                    <CardBody className="border border-top-0 border-end-0 border-start-0">
                      <form>
                        <Row>
                          <Col sm={1}>
                            <div className="me-2 mb-2 col-12">
                              <select className="form-select" value={pageSize} onChange={onChangeInSelect}> {[10, 25, 50, 100, 150, 250, 500, 1000, 2500, 5000].map((pageSize) => (
                                <option key={pageSize} value={pageSize}>{pageSize}</option>
                              ))}
                              </select>
                            </div>
                          </Col>
                          <Col sm={3}>
                            <div className="search-box me-2 mb-2 d-inline-block col-12">
                              <input
                                onChange={(e) => {
                                  setSearchValue(e.target.value);
                                  onChange(e.target.value);
                                  gotoPage(0);
                                }}
                                id="search-bar-0" type="text" className="form-control search"
                                placeholder={`${count} Cari...`} value={searchValue ?? ""} />
                              <i className="bx bx-search-alt search-icon"></i>
                            </div>
                          </Col>
                          <Col sm={4}>
                            <div className="search-box mb-2">
                              <Flatpickr className="form-control" id="datepicker-publish-input" placeholder="Pilih Tanggal"
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d"
                                }}
                                onChange={(selectedDates, dateStr) => { setFilterDate(dateStr); }} /><i className="bx bx-calendar-alt search-icon"></i>
                            </div>
                          </Col>

                          <Col sm={3}>
                            <div className="me-2 mb-2 col-12">
                              <Select
                                placeholder="Pilih Status"
                                onChange={(e) => {
                                  setStatusActive(e);
                                }}
                                options={statusActiveData}
                                name="choices-single-default"></Select>
                            </div>
                          </Col>

                          <Col sm={1}>
                            <div>
                              <button type="button" className="btn btn-light w-100" onClick={() => { handleFilter(); }}>
                                <i className="ri-search-line me-1 align-bottom fs-14"></i>
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                    </CardBody>
                  </Row>
                  <div className="table-responsive table-card mb-1">
                    <Table hover {...getTableProps()} className="align-middle table-nowrap">
                      <thead className="table-light">
                        {headerGroups.map((headerGroup, index) => (
                          <tr {...headerGroup.getHeaderGroupProps()} className={""} key={index}>
                            {headerGroup.headers.map((column, index) => (
                              <th key={index} className={"" + generateFilterable(column)} {...column.getSortByToggleProps()}>
                                {column.render("Header")}
                                {generateSortingIndicator(column)}
                                {/* <Filter column={column} /> */}
                              </th>
                            ))}
                          </tr>
                        ))}
                      </thead>

                      <tbody {...getTableBodyProps()}>
                        {page.map((row) => {
                          prepareRow(row);
                          return (
                            <Fragment key={row.getRowProps().key}>
                              <tr>
                                {row.cells.map((cell, index) => {
                                  return (
                                    <td {...cell.getCellProps()} key={index}>
                                      {cell.render("Cell")}
                                    </td>
                                  );
                                })}
                              </tr>
                            </Fragment>
                          );
                        })}
                      </tbody>
                    </Table>
                  </div>

                  <Row className="justify-content-md-end justify-content-center align-items-center p-2">
                    <Col className="col-md-auto d-none d-md-block">{rows.length} Data</Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button color="light" onClick={previousPage} disabled={!canPreviousPage}> {"<"} </Button>
                      </div>
                    </Col>
                    <Col className="col-md-auto d-none d-md-block"> Halaman {pageIndex + 1} dari {pageOptions.length}</Col>
                    <Col className="col-md-auto">
                      <Input type="number" min={1} style={{ width: 70 }} max={pageOptions.length} defaultValue={pageIndex + 1} onChange={onChangeInInput} />
                    </Col>
                    <Col className="col-md-auto">
                      <div className="d-flex gap-1">
                        <Button className="btn btn-light" onClick={nextPage} disabled={!canNextPage}>{">"}</Button>
                      </div>
                    </Col>
                  </Row>
                </div>
                <Modal id="showModal" isOpen={modal} centered size="md">
                  <ModalHeader className="bg-light p-3" toggle={toggle}>
                    {!!isEdit ? "Edit Target Penjualan" : "Tambah Target Penjualan"}
                  </ModalHeader>
                  <Form onSubmit={(e) => { e.preventDefault(); validation.handleSubmit(); return false; }}>
                    <ModalBody>
                      <div className="row">
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="mb-3">
                              <Label htmlFor="client-field" className="form-label">
                                Grup Usaha&nbsp; {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="client"
                                value={validation.values.client}
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                placeholder="Pilih Grup Usaha"
                                onChange={(e) => {
                                  setCompanyList([]);
                                  setBranchList([]);
                                  validation.setFieldValue("company", "");
                                  validation.setFieldValue("branch", "");
                                  validation.setFieldValue("client", e);
                                  handleGetCompany(e.value);
                                }}
                                options={clientList}></Select>
                              {validation.touched.client &&
                                validation.errors.client && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.client}
                                  </small>
                                )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="company-field" className="form-label">
                                Perusahaan&nbsp; {companyLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="company"
                                value={validation.values.company}
                                placeholder="Pilih Perusahaan"
                                isDisabled={userType === "admin" || userType === "client" ? false : true}
                                onChange={(e) => {
                                  setBranchList([]);
                                  validation.setFieldValue("branch", "");
                                  validation.setFieldValue("company", e);
                                  handleGetBranch(e.value);
                                }}
                                options={companyList}></Select>
                              {validation.touched.company &&
                                validation.errors.company && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.company}
                                  </small>
                                )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="branch-field" className="form-label" >
                                Branch&nbsp; {branchLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="branch"
                                value={validation.values.branch}
                                placeholder="Select Branch"
                                onChange={(e) => {
                                  validation.setFieldValue("branch", e);
                                }}
                                options={branchList}></Select>
                              {validation.touched.branch &&
                                validation.errors.branch && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.branch}
                                  </small>
                                )}
                            </div>

                            <div className="mb-3">
                              <Label htmlFor="channel-field" className="form-label" >
                                Channel&nbsp; {clientLoading && (
                                  <Spinner color="primary" size="sm">
                                    Loading...
                                  </Spinner>
                                )}
                              </Label>
                              <Select
                                name="channel"
                                value={validation.values.channel}
                                placeholder="Select Channel"
                                onChange={(e) => {
                                  validation.setFieldValue("channel", e);
                                }}
                                options={channelList}></Select>
                              {validation.touched.channel &&
                                validation.errors.channel && (
                                  <small className="text-danger" type="invalid">
                                    {validation.errors.channel}
                                  </small>
                                )}
                            </div>
                            <div className="mb-3">
                              <Label htmlFor="targetat-field" className="form-label">
                                Target Periode
                              </Label>
                              <Flatpickr
                                name="targetat"
                                className="form-control"
                                id="targetat"
                                placeholder="Select Task Range Date"
                                value={validation.values.targetat}
                                options={{
                                  enableTime: true,
                                  time_24hr: true,
                                  mode: "range",
                                  dateFormat: "Y/m/d H:i",
                                }}
                                onChange={(obj, str) => {
                                  validation.setFieldValue("targetat", str);
                                }} />
                              {validation.touched.targetat &&
                                validation.errors.targetat ? (
                                <small className="text-danger" type="invalid">
                                  {validation.errors.targetat}
                                </small>
                              ) : null}
                            </div>
                            <div className="mb-3 col-lg-6">
                              <Label htmlFor="amount-field" className="form-label"> Target Amount </Label>
                              <Input name="amount" id="amount-field" className="form-control" placeholder="Enter amount" type="number"
                                onChange={validation.handleChange}
                                onBlur={validation.handleBlur}
                                value={validation.values.amount ?? ""}
                                invalid={validation.touched.amount && validation.errors.amount ? true : false} />
                              {validation.touched.amount && validation.errors.amount ? (
                                <FormFeedback type="invalid">{validation.errors.amount}</FormFeedback>
                              ) : null}
                            </div>
                          </div>
                          <div className="mb-4">
                            <Label htmlFor="description-field" className="form-label">Keterangan</Label>
                            <Input name="description" id="description-field" className="form-control" placeholder="Isi Keterangan" type="textarea"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.description ?? ""} />
                          </div>

                        </div>
                      </div>
                    </ModalBody>
                    <div className="modal-footer">
                      <div className="hstack gap-2 justify-content-end">
                        <button type="button" className="btn btn-light" onClick={() => { setModal(false); }}> Close </button>
                        <button type="submit" className="btn btn-success">
                          <span className="d-flex align-items-center">
                            <span className="flex-grow-1 me-2">
                              {!!isEdit ? "Update" : "Simpan Target Penjualan"}
                            </span>
                            {loading && (<Spinner size="sm" className="flex-shrink-0" role="company"> Loading... </Spinner>)}
                          </span>
                        </button>
                      </div>
                    </div>
                  </Form>
                </Modal>

              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div >
  );
};

export default SalesTarget;


